import { Administrateur } from './administrateur.model';
import { ParametreContextuel } from './parametre-contextuel.model';
import { Structure } from './structure-type.model';

export type TypeHabilitation =
  'CL'
  | 'GAE'
  | 'GARS'
  | 'DELEGUE'
  | 'MANDATAIRE'
  | 'DELEGUE_GENERIQUE'
  | 'DELEGUE_PM'
  | 'ADMIN_GENERIQUE'
  | 'CL_PM';

export enum HabilitationStatesEnum {
  OUVERT = 'OUVERT',
  FERME = 'FERME',
  EN_ATTENTE_DE_VALIDATION = 'EN_ATTENTE_DE_VALIDATION',
  REJETE = 'REJETE',
  ABANDONNE = 'ABANDONNE'
}

export enum HabilitationType {
  CL = 'CL',
  GAE = 'GAE',
  GARS = 'GARS',
  DELEGUE = 'DELEGUE',
  MANDATAIRE = 'MANDATAIRE',
  DELEGUE_GENERIQUE = 'DELEGUE_GENERIQUE',
  DELEGUE_PM = 'DELEGUE_PM',
  ADMIN_GENERIQUE = 'ADMIN_GENERIQUE',
  CL_PM = 'CL_PM',
  REPRESENTANT_LEGAL = 'REPRESENTANT_LEGAL'
}



export type Habilitation = {
  structure: Structure;
  certificat: ParametreContextuel;
  admin: Administrateur[];
  type: TypeHabilitation;
  typeOffre?: string;
};

export type HabilitationMultiple = {
  structure: Structure[];
  certificat: ParametreContextuel;
  admin: Administrateur[];
  type: TypeHabilitation;
  typeOffre?: string;
  unknownStructuresInRASS?: Map<Structure, number>;
  structureCheckedInRass?: Structure[];
};
